export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20crimson%20and%20amber%20lighting%2C%20velvet%20curtains%2C%20soft%20glow%2C%20abstract%20film%20reel%20texture%2C%20luxurious%20gold%20accents%2C%20dramatic%20yet%20elegant%20composition%2C%20rich%20dark%20gradient%20background%20with%20subtle%20lens%20flare&width=1800&height=900&seq=hero-cinema-bg&orientation=landscape"
          alt="菲菲影院电影氛围背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-400 text-sm font-medium mb-5">
              海量高清 · 不缓冲 · 免费看
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              菲菲影院 - 电影大全免费在线观看
            </h1>
            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              最新电影，随时随地免费看
            </p>
            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              菲菲影院汇聚海量电影资源，涵盖最新高清电影、高分动作片、喜剧片等丰富类型，
              每日持续更新热门影片。无需注册即可免费在线观看，流畅不缓冲，
              为你打造极致的观影体验。无论经典老片还是院线新作，这里都有你想看的。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">20000+</div>
                <div className="text-xs text-white/55 mt-1">部电影资源</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">1080P</div>
                <div className="text-xs text-white/55 mt-1">高清画质</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">每日更新</div>
                <div className="text-xs text-white/55 mt-1">不停歇</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 text-white border border-white/20 rounded-lg font-medium text-sm hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20poster%20collage%20with%20warm%20crimson%20and%20gold%20tones%2C%20vintage%20movie%20poster%20aesthetic%2C%20dramatic%20lighting%2C%20film%20strip%20elements%2C%20classic%20cinema%20vibe%2C%20art%20deco%20details%2C%20rich%20textures%2C%20no%20text%20just%20atmospheric%20visual%20composition&width=800&height=1000&seq=hero-cinema-poster&orientation=portrait"
                alt="菲菲影院主视觉 - 电影海报艺术"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}